import { Component, Prop, Watch } from 'vue-property-decorator';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';
import StripePaymentModal from '@accounting/components/payments/stripe/stripe-payment-modal.vue';
import { CenterSetting } from '@core/interfaces/center-setting';

@Component({
  name: 'bpc-payment-method-accordion',
  components: {
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-stripe-payment-modal': StripePaymentModal,
  },
})
export default class PaymentMethodAccordion extends Vue {
  public paymentMethodOptions = [];

  @Prop(String) readonly value: string;
  @Prop({ type: Boolean, default: false }) readonly isFree: boolean;

  get model(): string {
    return this.value;
  }

  set model(value: string) {
    this.$emit('input', value);
  }

  mounted() {
    this.setPaymentMethods();
  }

  get centerSetting(): CenterSetting {
    const tenant = this.$authService.getSelectedTenant();
    return tenant.center_setting || null;
  }

  onClickPaymentMethod(index: number) {
    this.$root.$emit('bv::toggle::collapse', 'accordion' + index);
  }

  setPaymentMethods() {
    this.paymentMethodOptions = [];
    if (this.isFree) {
      this.paymentMethodOptions.push({
        value: 'free',
        text: 'global.payment_method.free.label',
        description: 'global.payment_method.free.description',
      });
    } else {
      if (this.centerSetting.money_transfer_activated) {
        this.paymentMethodOptions.push({
          value: 'money_transfer',
          text: 'global.payment_method.money_transfer.label',
          description: 'global.payment_method.money_transfer.description',
        });
      }
      if (this.centerSetting.stripe_activated) {
        this.paymentMethodOptions.push({
          value: 'stripe_card',
          text: 'global.payment_method.stripe.label',
          description: 'global.payment_method.stripe.description',
        });
      }
      if (this.centerSetting.bancontact_activated) {
        this.paymentMethodOptions.push({
          value: 'stripe_bancontact',
          text: 'global.payment_method.bancontact.label',
          description: 'global.payment_method.bancontact.description',
        });
      }
      if (this.centerSetting.payfip_activated) {
        this.paymentMethodOptions.push({
          value: 'payfip',
          text: 'global.payment_method.payfip.label',
          description: 'global.payment_method.payfip.description',
        });
      }
    }
  }

  @Watch('isFree')
  onChangeIsFree() {
    this.setPaymentMethods();
  }
}
